import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { IDENTITAS_DATAKELAS_TABLE_FIELDS } from '../../../constants/Akademi/DataKelas/identitas.constant';

export default class Identitas extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);

  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/administrasi/data-kelas/buat-identitas-sekolah');
  }

  onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/keuangan/penganggaran/tipe-anggaran', { data: val });
  }



  render() {
    const { handleGetBudget, handleDeleteBudget } = this.props;
    return (
      <div className="budget">
        <Button
          title="Buat Identitas Sekolah"
          onClick={this.onClickAdd}
        />
        <div className="budget__content">
         <ContentTable
            onSearchContent={handleGetBudget}
            tableFields={IDENTITAS_DATAKELAS_TABLE_FIELDS}
            onClickEdit={this.onClickEdit}
            onClickDelete={handleDeleteBudget}
          />
        </div>
      </div>
    );
  }
}


// Budget.propTypes = {
//   handleGetBudget: PropTypes.func,
//   handleDeleteBudget: PropTypes.func,
//   user: PropTypes.object,
//   history: PropTypes.object.isRequired,
// };
// Budget.defaultProps = {
//   handleGetBudget: noop,
//   handleDeleteBudget: noop,
//   user: null,
// };

Identitas.propTypes = {
  handleGetBudget: PropTypes.func,
  handleDeleteBudget: PropTypes.func,
  user: PropTypes.object,
  history: PropTypes.object.isRequired,
};
Identitas.defaultProps = {
  handleGetBudget: noop,
  handleDeleteBudget: noop,
  user: null,
};
